/*
 * Jane Lushka v1.2: the Wishlist page and Recently viewed (phase 4, K16, K17). Loaded (defer) only by
 * sections/jl-wishlist-page.liquid and sections/jl-recently-viewed.liquid, after assets/jl-lists.js
 * (window.JLWishlist, window.JLRecent). window.JLListsPage = { __v, init(root) }; jl-lists.js calls init on
 * shopify:section:load.
 *
 * Cards come from the Section Rendering API, <root>products/<handle>?section_id=jl-product-card, 6 requests at a
 * time. The URL is the same for both lists (the list name, image sizes and quick add source are set here while the
 * card is still inert), so one product is one cache entry. A card's HTML is also kept in sessionStorage
 * "jl:cards:v2" = { "<root>|<currency>-<country>|<handle>": { t: time (ms), h: card HTML } }, the 16 newest, 10 minutes,
 * so the next product page fills Recently viewed without a request (the version goes up whenever the card markup
 * changes: v2 = the phase 5 card, review C6). A 404 drops the handle from its list (only
 * when another card of the same batch loaded, so a missing section never empties a list).
 * Every card fills a slot that is already in the page at the card's size (li.jl-slot with a skeleton,
 * assets/jl-lists.css), so nothing below moves when the cards arrive.
 *   Recently viewed: the slots are stamped and the section shown when this script runs (the rail is far below
 *   the fold); the cards load when it comes within 400px of the viewport, then jl:recently-viewed-shown { count }
 *   is dispatched. Slots whose card failed are removed once the section is out of view (no card at all: the
 *   section hides again). No other handle (first visit, storage blocked): the section stays hidden.
 *   Wishlist page: an inline script in the section reads jl:wishlist:v1 before the first paint and stamps one
 *   slot per saved handle (at most 48) or shows the empty state, and sets data-cols. Here the slots get their
 *   handles and the cards load 12 at a time: the first 12 at once, each later 12 when one of their slots comes
 *   within 600px of the viewport. aria-busy on the grid is true while a batch loads.
 * Every storage access is wrapped.
 */
(function () {
  'use strict';

  if (window.JLListsPage && window.JLListsPage.__v) return;

  var PARALLEL = 6;
  var BATCH = 12;
  var COLS_KEY = 'jl:grid-cols:v1';
  var CACHE_KEY = 'jl:cards:v2';
  var CACHE_TTL = 600000;
  var CACHE_MAX = 16;
  var PAGE_SEL = '[data-jl-recent], [data-jl-wishlist-page]';
  /* Recently viewed: 42vw phone row; 4 columns (gap 24) inside 32 / 40 / 56px padding, at most 1440px wide */
  var RAIL_SIZES = '(min-width: 1440px) 314px, (min-width: 1280px) calc((100vw - 184px) / 4), (min-width: 1024px) calc((100vw - 152px) / 4), (min-width: 768px) calc((100vw - 136px) / 4), 42vw';
  /* Wishlist page at 4 columns (the section prints the 3 column sizes) */
  var WL4_SIZES = '(min-width: 1024px) calc((100vw - 2 * clamp(20px, 3.9vw, 56px) - 72px) / 4), (min-width: 768px) calc((100vw - 2 * clamp(20px, 3.9vw, 56px) - 32px) / 3), 44vw';
  var SKELETON = '<div class="jl-skel" aria-hidden="true"><span class="jl-skel__img"></span><span class="jl-skel__text"></span></div>';

  var memo = {};

  /* ---------------- helpers ---------------- */

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) {
    root = root || document;
    return root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function emit(name, detail) {
    var ev;
    try {
      ev = new CustomEvent(name, { detail: detail, bubbles: true });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, true, false, detail);
    }
    document.dispatchEvent(ev);
  }

  function cleanHandle(h) {
    h = String(h == null ? '' : h).trim();
    if (!h || h.length > 255 || /[\s\/?#"'<>\\]/.test(h)) return '';
    return h;
  }

  function readString(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function rootOf(el) {
    var r = (el && el.getAttribute('data-root')) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }

  /* card prices follow the currency and, with Markets, the country (one currency can have several price lists) */
  function currency() {
    var s = window.Shopify || {};
    return ((s.currency && s.currency.active) || '') + (s.country ? '-' + s.country : '');
  }

  function slotsOf(list) {
    return Array.prototype.filter.call(list.children, function (li) { return li.classList.contains('jl-slot'); });
  }

  function makeSlot(cls, h) {
    var li = document.createElement('li');
    li.className = cls + ' jl-slot';
    li.innerHTML = SKELETON;
    if (h) li.setAttribute('data-handle', h);
    return li;
  }

  function fill(li, card) {
    li.appendChild(card);
    li.classList.add('is-filled');
  }

  function whenNear(el, margin, fn) {
    if (!('IntersectionObserver' in window)) {
      fn();
      return null;
    }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      io.disconnect();
      fn();
    }, { rootMargin: margin + 'px 0px ' + margin + 'px 0px' });
    io.observe(el);
    return io;
  }

  function whenAway(el, fn) {
    if (!('IntersectionObserver' in window)) {
      fn();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) return;
      io.disconnect();
      fn();
    });
    io.observe(el);
  }

  function mapLimit(items, limit, fn) {
    return new Promise(function (resolve) {
      var results = new Array(items.length);
      var next = 0;
      var done = 0;
      if (!items.length) {
        resolve(results);
        return;
      }
      function run() {
        if (next >= items.length) return;
        var i = next++;
        Promise.resolve().then(function () { return fn(items[i], i); }).then(function (r) { results[i] = r; }, function () { results[i] = null; }).then(function () {
          done++;
          if (done === items.length) resolve(results);
          else run();
        });
      }
      for (var k = 0; k < Math.min(limit, items.length); k++) run();
    });
  }

  /* ---------------- card cache (sessionStorage, always wrapped) ---------------- */

  function cacheRead() {
    try {
      var o = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
    } catch (e) {
      return {};
    }
  }

  function fresh(e, now) {
    return !!e && typeof e.h === 'string' && typeof e.t === 'number' && e.t <= now && now - e.t <= CACHE_TTL;
  }

  function cacheGet(key) {
    var e = cacheRead()[key];
    return fresh(e, Date.now()) ? e.h : '';
  }

  function cachePut(key, html) {
    var o = cacheRead();
    var now = Date.now();
    o[key] = { t: now, h: html };
    var keep = Object.keys(o).filter(function (k) { return fresh(o[k], now); });
    keep.sort(function (a, b) { return o[b].t - o[a].t; });
    var out = {};
    keep.slice(0, CACHE_MAX).forEach(function (k) { out[k] = o[k]; });
    try {
      window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(out));
    } catch (e) {
      try { window.sessionStorage.removeItem(CACHE_KEY); } catch (e2) { /* storage blocked */ }
    }
  }

  /* ---------------- cards through the Section Rendering API ---------------- */

  function cardHtml(text) {
    var tpl = document.createElement('template');
    tpl.innerHTML = text;
    var card = tpl.content ? tpl.content.querySelector('[data-product-card]') : null;
    return card ? card.outerHTML : '';
  }

  /* resolves { html } | { gone: true } (404) | { error: true } | { empty: true } (no card in the answer);
     one request per root + currency and country + handle per page life */
  function fetchCard(root, handle) {
    var key = root + '|' + currency() + '|' + handle;
    if (memo[key]) return memo[key];
    var hit = cacheGet(key);
    if (hit) {
      memo[key] = Promise.resolve({ html: hit });
      return memo[key];
    }
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=jl-product-card';
    var p;
    try {
      p = window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
        if (r.status === 404) return { gone: true };
        if (!r.ok) return { error: true };
        return r.text().then(function (t) {
          var html = cardHtml(t);
          if (!html) return { empty: true };
          cachePut(key, html);
          return { html: html };
        });
      }).catch(function () { return { error: true }; });
    } catch (e) {
      p = Promise.resolve({ error: true });
    }
    memo[key] = p;
    p.then(function (res) { if (res.error) delete memo[key]; });
    return p;
  }

  /* the list name and image sizes the section could not print (Liquid has no query string), set while the card is
     still inert, so its photo is requested once, at the width it is shown */
  function prepCard(card, list, index, sizes) {
    card.setAttribute('data-jl-list', list);
    card.setAttribute('data-jl-index', String(index));
    qsa('[data-jl-source]', card).forEach(function (b) { b.setAttribute('data-jl-source', list); });
    if (sizes) qsa('img[sizes]', card).forEach(function (img) { img.setAttribute('sizes', sizes); });
  }

  function cardFrom(html, list, index, sizes) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var card = tpl.content ? tpl.content.querySelector('[data-product-card]') : null;
    if (!card) return null;
    prepCard(card, list, index, sizes);
    return document.importNode(card, true);
  }

  function renumber(list) {
    qsa('[data-product-card]', list).forEach(function (card, i) { card.setAttribute('data-jl-index', String(i + 1)); });
  }

  function focusTarget(li) {
    if (!li) return null;
    return qs('.jl-card__link', li) || qs('a[href]:not([tabindex="-1"])', li) || qs('button:not([disabled])', li);
  }

  function filledSibling(li, dir) {
    var x = li[dir];
    while (x && !x.classList.contains('is-filled')) x = x[dir];
    return x;
  }

  /* ---------------- Wishlist page ---------------- */

  function applyCols(sec) {
    sec.setAttribute('data-cols', readString(COLS_KEY) === '4' ? '4' : '3');
  }

  function setEmpty(sec, on) {
    var empty = qs('[data-jl-wl-empty]', sec);
    if (empty) empty.hidden = !on;
    sec.classList.toggle('jl-wl--empty', !!on);
  }

  function toRemoveButtons(card, sec) {
    var tpl = sec.getAttribute('data-remove-named') || '';
    qsa('[data-jl-wishlist]', card).forEach(function (b) {
      b.setAttribute('data-jl-wl-remove', '');
      b.removeAttribute('aria-pressed');
      b.classList.add('is-saved');
      var name = b.getAttribute('data-item-name') || '';
      if (tpl) b.setAttribute('aria-label', tpl.split('[name]').join(name));
    });
  }

  /* one slot per handle, in order: filled slots are kept by handle, the skeletons the inline script stamped are
     reused, and the DOM is only touched when something changed */
  function reconcile(grid, handles) {
    var kids = slotsOf(grid);
    var byHandle = {};
    var spare = [];
    kids.forEach(function (li) {
      var h = li.getAttribute('data-handle');
      if (h && handles.indexOf(h) >= 0 && !byHandle[h]) byHandle[h] = li;
      else if (!li.classList.contains('is-filled')) spare.push(li);
    });
    var want = handles.map(function (h) {
      var li = byHandle[h];
      if (!li) {
        li = spare.shift() || makeSlot('jl-wl__item');
        li.setAttribute('data-handle', h);
      }
      return li;
    });
    Array.prototype.slice.call(grid.children).forEach(function (el) { if (want.indexOf(el) < 0) grid.removeChild(el); });
    var same = want.length === grid.children.length && want.every(function (li, i) { return grid.children[i] === li; });
    if (!same) want.forEach(function (li) { grid.appendChild(li); });
  }

  function loadBatch(sec, grid, slots, token) {
    var st = sec.__jlWl;
    st.inflight++;
    grid.setAttribute('aria-busy', 'true');
    var root = rootOf(sec);
    var sizes = sec.getAttribute('data-cols') === '4' ? WL4_SIZES : '';
    var handles = slots.map(function (li) { return li.getAttribute('data-handle'); });
    mapLimit(handles, PARALLEL, function (h, i) {
      return fetchCard(root, h).then(function (res) {
        var li = slots[i];
        if (res && res.html && li.parentNode === grid && li.getAttribute('data-handle') === h && !li.classList.contains('is-filled')) {
          var card = cardFrom(res.html, 'wishlist', slotsOf(grid).indexOf(li) + 1, sizes);
          if (card) {
            toRemoveButtons(card, sec);
            fill(li, card);
          }
        }
        return res;
      });
    }).then(function (results) {
      st.inflight--;
      if (st.token === token) {
        var anyOk = results.some(function (r) { return r && r.html; });
        results.forEach(function (res, i) {
          var li = slots[i];
          if (li.classList.contains('is-filled')) return;
          /* 404: dropped from storage; network trouble: kept in storage, shown next time */
          if (res && res.gone && anyOk) window.JLWishlist.drop(handles[i]);
          if (li.parentNode) li.parentNode.removeChild(li);
        });
        renumber(grid);
        if (!slotsOf(grid).length) setEmpty(sec, true);
      }
      if (!st.inflight) grid.setAttribute('aria-busy', 'false');
    });
  }

  function renderWishlistPage(sec) {
    var grid = qs('[data-jl-wl-grid]', sec);
    if (!grid || !window.JLWishlist) return;
    var st = sec.__jlWl || (sec.__jlWl = { token: 0, inflight: 0, io: null });
    st.token++;
    if (st.io) {
      st.io.disconnect();
      st.io = null;
    }
    applyCols(sec);
    var max = parseInt(sec.getAttribute('data-max'), 10) || 48;
    var handles = window.JLWishlist.list().slice(0, max);
    if (!handles.length) {
      grid.innerHTML = '';
      if (!st.inflight) grid.setAttribute('aria-busy', 'false');
      setEmpty(sec, true);
      return;
    }
    setEmpty(sec, false);
    reconcile(grid, handles);
    renumber(grid);
    var pending = slotsOf(grid).filter(function (li) { return !li.classList.contains('is-filled'); });
    if (!pending.length) {
      if (!st.inflight) grid.setAttribute('aria-busy', 'false');
      return;
    }
    var token = st.token;
    var batches = [];
    for (var i = 0; i < pending.length; i += BATCH) batches.push(pending.slice(i, i + BATCH));
    loadBatch(sec, grid, batches.shift(), token);
    if (!batches.length) return;
    if (!('IntersectionObserver' in window)) {
      batches.forEach(function (b) { loadBatch(sec, grid, b, token); });
      return;
    }
    var io = st.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var b = en.isIntersecting && en.target.__jlBatch;
        if (!b || b.started || st.token !== token) return;
        b.started = true;
        b.forEach(function (li) { io.unobserve(li); });
        loadBatch(sec, grid, b, token);
      });
    }, { rootMargin: '600px 0px 600px 0px' });
    batches.forEach(function (b) {
      b.forEach(function (li) {
        li.__jlBatch = b;
        io.observe(li);
      });
    });
  }

  function removeFromPage(sec, h) {
    var grid = qs('[data-jl-wl-grid]', sec);
    if (!grid) return;
    var li = null;
    slotsOf(grid).some(function (x) {
      if (x.getAttribute('data-handle') === h) li = x;
      return !!li;
    });
    if (!li) return;
    var hadFocus = li.contains(document.activeElement);
    var next = focusTarget(filledSibling(li, 'nextElementSibling')) || focusTarget(filledSibling(li, 'previousElementSibling'));
    li.parentNode.removeChild(li);
    renumber(grid);
    var left = slotsOf(grid).length;
    if (!left) setEmpty(sec, true);
    if (!hadFocus) return;
    var target = left ? next : qs('[data-jl-wl-empty] a', sec);
    if (target) {
      try { target.focus({ preventScroll: false }); } catch (e) { target.focus(); }
    }
  }

  function initWishlistPage(sec) {
    if (!sec || sec.__jlWlInit || !window.JLWishlist) return;
    sec.__jlWlInit = true;
    renderWishlistPage(sec);
  }

  /* ---------------- Recently viewed ---------------- */

  function loadRecent(sec, list) {
    var slots = slotsOf(list);
    var handles = slots.map(function (li) { return li.getAttribute('data-handle'); });
    var root = rootOf(sec);
    mapLimit(handles, PARALLEL, function (h, i) {
      return fetchCard(root, h).then(function (res) {
        var card = res && res.html ? cardFrom(res.html, 'recently_viewed', i + 1, RAIL_SIZES) : null;
        if (card) fill(slots[i], card);
        return res;
      });
    }).then(function (results) {
      var anyOk = results.some(function (r) { return r && r.html; });
      results.forEach(function (res, i) {
        if (slots[i].classList.contains('is-filled')) return;
        if (res && res.gone && anyOk) window.JLRecent.drop(handles[i]);
        slots[i].classList.add('is-failed');
      });
      renumber(list);
      list.setAttribute('aria-busy', 'false');
      if (!sec.isConnected) return;
      var n = qsa('.jl-slot.is-filled', list).length;
      if (n) emit('jl:recently-viewed-shown', { count: n });
      if (n === slots.length) return;
      /* failed slots leave once nobody sees them go (no layout shift) */
      whenAway(sec, function () {
        qsa('.jl-slot.is-failed', list).forEach(function (li) { li.parentNode.removeChild(li); });
        if (!slotsOf(list).length) sec.hidden = true;
      });
    });
  }

  function initRecent(sec) {
    if (!sec || sec.__jlRvInit || !window.JLRecent) return;
    sec.__jlRvInit = true;
    var current = cleanHandle(sec.getAttribute('data-handle'));
    var exclude = (sec.getAttribute('data-exclude') || '').split(',').map(cleanHandle).filter(Boolean);
    if (current) {
      window.JLRecent.record(current);
      exclude.push(current);
    }
    var max = parseInt(sec.getAttribute('data-max'), 10) || 8;
    var handles = window.JLRecent.list().filter(function (h) { return exclude.indexOf(h) < 0; }).slice(0, max);
    var list = qs('[data-jl-recent-list]', sec);
    if (!handles.length || !list) return; /* first visit or storage blocked: the section stays hidden */
    list.innerHTML = '';
    handles.forEach(function (h) { list.appendChild(makeSlot('jl-recent__item', h)); });
    list.setAttribute('aria-busy', 'true');
    sec.hidden = false;
    whenNear(sec, 400, function () { loadRecent(sec, list); });
  }

  /* ---------------- wiring ---------------- */

  function init(root) {
    root = root || document;
    var secs = qsa(PAGE_SEL, root);
    if (root.matches && root.matches(PAGE_SEL)) secs.push(root);
    secs.forEach(function (sec) {
      if (sec.hasAttribute('data-jl-recent')) initRecent(sec);
      else initWishlistPage(sec);
    });
  }

  window.JLListsPage = { __v: 1, init: init };

  /* the Wishlist page follows every change (its own remove buttons, other tabs, back/forward cache) */
  document.addEventListener('jl:wishlist-change', function (e) {
    var d = e.detail || {};
    qsa('[data-jl-wishlist-page]').forEach(function (sec) {
      if (!sec.__jlWlInit) return;
      if (d.action === 'remove') removeFromPage(sec, d.handle);
      else renderWishlistPage(sec);
    });
  });

  function rerender() {
    qsa('[data-jl-wishlist-page]').forEach(function (sec) { if (sec.__jlWlInit) renderWishlistPage(sec); });
  }

  window.addEventListener('storage', function (e) {
    if (e.key === 'jl:wishlist:v1' || e.key === null) rerender();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) rerender();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
